import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Cockpit from './pages/Cockpit';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Demo from './pages/Demo';

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="cockpit" element={<Cockpit />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="demo" element={<Demo />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}